import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  //ボタン押下でアコーディオン開閉
  open(e) {
    e.preventDefault();
    const toggle = $(e.currentTarget).closest(".js-toggle");
    const panel = $(`#${$(e.currentTarget).attr("aria-controls")}`);

    if (toggle.hasClass("is-open")) {
      toggle.removeClass("is-open");
      panel.slideUp();
      // aria属性
      $(e.currentTarget).attr("aria-expanded", false);
      panel.attr("aria-hidden", true);
    } else {
      toggle.addClass("is-open");
      panel.slideDown();
      // aria属性
      $(e.currentTarget).attr("aria-expanded", true);
      panel.attr("aria-hidden", false);
    }
  }
}
